/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  PicklistWithData,
  FileTypePicklist
} from '../'

export const FilterComboFileType = ({ language, audience, fileType, onLanguageChange, onAudienceChange, onFileTypeChange, disabled }) => (
  <div className="sidebar__item slds-p-around_large">
    <Language
      value={language}
      onChange={onLanguageChange}
    />
    <Audience
      value={audience}
      onChange={onAudienceChange}
    />
    <FileType
      value={fileType}
      language={language}
      audience={audience}
      onChange={onFileTypeChange}
    />
  </div>
)

FilterComboFileType.propTypes = {
  language: PropTypes.string.isRequired,
  fileType: PropTypes.string.isRequired,
  onLanguageChange: PropTypes.func.isRequired,
  onFileTypeChange: PropTypes.func.isRequired
}

const Language = ({ value, onChange }) => (
  <div className='slds-grid slds-wrap slds-m-bottom_medium'>
    <div className="slds-col slds-size_1-of-1 sidebar__item__title">
      Language
    </div>
    <div className="slds-col slds-size_3-of-4">
      <div className="sidebar__item__choice">
        <PicklistWithData
          id='language'
          forField='FileTypeLanguage'
          default='All'
          symbol='chevrondown'
          value={value === ''
            ? 'all'
            : value
          }
          onChange={onChange}
          closeDropdownOnSelect={true}
          inline={true}
        />
      </div>
    </div>
  </div>
)

const Audience = ({ value, onChange }) => (
  <div className='slds-grid slds-wrap slds-m-bottom_medium'>
    <div className="slds-col slds-size_1-of-1 sidebar__item__title">
      Audience
    </div>
    <div className="slds-col slds-size_3-of-4">
      <div className="sidebar__item__choice">
        <PicklistWithData
          id='audience'
          forField='FileTypeAudience'
          default='All'
          symbol='chevrondown'
          value={value === ''
            ? 'all'
            : value
          }
          onChange={onChange}
          closeDropdownOnSelect={true}
          inline={true}
        />
      </div>
    </div>
  </div>
)

const FileType = ({ value, language, audience, onChange, disabled }) => (
  <div className='slds-grid slds-wrap'>
    <div className="slds-col slds-size_1-of-1 sidebar__item__title">
      File type
    </div>
    <div className="slds-col slds-size_3-of-4">
      <div className="sidebar__item__choice">
        <FileTypePicklist
          id='fileType'
          field='name'
          language={language}
          audience={audience}
          defaultValue='All'
          value={value || ''}
          evaluateShortCode={language ? false : true}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/filter-combo-filetype/index.js